import { FiDollarSign, FiCheckCircle, FiAlertCircle, FiArchive } from 'react-icons/fi';
import { StatCard, StatCardGrid } from '../../components/common';
import { SUMMARY, ENTITIES, pluralize } from '../../constants/labels';
import { fmtCurrency } from '../../utils/formatNumber';
import { OFFERING_LABEL } from './offeringsConfig';

export default function OfferingsSummaryCards({ totalOffered, totalPaid, totalPending, count }) {
  return (
    <StatCardGrid>
      <StatCard
        icon={<FiDollarSign size={18} />}
        iconBg="rgba(99,102,241,0.12)"
        iconColor="#6366f1"
        label={SUMMARY.totalOffered}
        value={fmtCurrency(totalOffered)}
      />
      <StatCard
        icon={<FiCheckCircle size={18} />}
        iconBg="rgba(16,185,129,0.12)"
        iconColor="#10b981"
        label={SUMMARY.collected}
        value={fmtCurrency(totalPaid)}
        valueColor="green"
      />
      <StatCard
        icon={<FiAlertCircle size={18} />}
        iconBg="rgba(239,68,68,0.12)"
        iconColor="#ef4444"
        label={SUMMARY.outstanding}
        value={fmtCurrency(totalPending)}
        valueColor="red"
      />
      <StatCard
        icon={<FiArchive size={18} />}
        iconBg="rgba(245,158,11,0.12)"
        iconColor="#f59e0b"
        label={`Total ${OFFERING_LABEL.plural}`}
        value={String(count)}
      />
    </StatCardGrid>
  );
}
